<p-toast position="bottom-right"></p-toast>
<!-- need to add translation for label p-buttons -->
<div class="call-overview">
  <h2 class="heading">{{ 'CALL_DETAILS_PAGE.CALL_DETAILS_PAGE_HEADING' | translate }}</h2>
  <p-button
    label="{{ 'CALL_DETAILS_PAGE.RECORDING_BUTTONS.CALL_NOT_RECORDED' | translate }}"
    class="p-button-disabled recording-button"
    *ngIf="callData?.data?.isRecorded === false"
    disabled
  ></p-button>
  <p-button
    label="{{ 'CALL_DETAILS_PAGE.RECORDING_BUTTONS.GET_RECORDING' | translate }}"
    icon="pi pi-video"
    class="p-button-primary recording-button"
    *ngIf="
      recordingStatus === recordingStatuesList.NOT_INITIATED && callData?.data?.isRecorded === true
    "
    (onClick)="getCallRecordingForDownloadMP4(callId || '')"
  ></p-button>
  <p-button
    label="{{ 'CALL_DETAILS_PAGE.RECORDING_BUTTONS.GET_IT_READY' | translate }}"
    icon="pi pi-spinner"
    class="p-button-warning recording-button"
    *ngIf="
      recordingStatus === recordingStatuesList.IN_PROGRESS && callData?.data?.isRecorded === true
    "
    (onClick)="getCallRecordingForDownloadMP4(callId || '')"
  ></p-button>
  <p-button
    label="{{ 'CALL_DETAILS_PAGE.RECORDING_BUTTONS.DOWNLOAD_RECORDING' | translate }}"
    icon="pi pi-download"
    class="p-button-success recording-button"
    *ngIf="
      recordingStatus === recordingStatuesList.COMPLETED && callData?.data?.isRecorded === true
    "
    (onClick)="
      downloadRecording(recordingURL || '', 'CALL_DETAILS_PAGE.RECORDING_CALL_FILENAME | translate')
    "
  ></p-button>
  <p-button
    label="{{ 'CALL_DETAILS_PAGE.RECORDING_BUTTONS.RETRY_RECORDING' | translate }}"
    icon="pi pi-refresh"
    class="p-button-danger recording-button"
    *ngIf="recordingStatus === recordingStatuesList.FAILED && callData?.data?.isRecorded === true"
    (onClick)="getCallRecordingForDownloadMP4(callId || '')"
  ></p-button>
  <div class="call-details row g-3" *ngIf="callData">
    <div class="col-md-12 col-lg-12 col-xl-4">
      <div class="user-info">
        <div class="user">
          <div class="name">
            <span>{{ callData.data.callerName }}</span>
            <span class="role">{{ 'CALL_DETAILS_PAGE.CALLER' | translate }}</span>
          </div>
          <img
            *ngIf="callerAvatar"
            [src]="baseApiUrl + callerAvatar"
            title="icon-person"
            alt="Caller Image"
          />
          <img *ngIf="!callerAvatar" src="assets/icons/icon-profile.png" alt="Caller Image" />
        </div>
        <div class="user">
          <div class="name">
            <span>{{ callData.data.talkingBuddyName }}</span>
            <span class="role">{{ 'CALL_DETAILS_PAGE.TALKING_BUDDY' | translate }}</span>
          </div>
          <div class="image-container">
            <img
              *ngIf="talkingBuddyAvatar"
              [src]="baseApiUrl + talkingBuddyAvatar"
              title="icon-person"
              alt="Caller Image"
            />
            <img
              *ngIf="!talkingBuddyAvatar"
              src="assets/icons/icon-profile.png"
              alt="Caller Image"
            />
            <span class="badge">
              <img src="assets/icons/tb-logo.svg" alt="Talking Buddy Badge" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4">
      <div class="call-summary">
        <div class="summary-item">
          <span class="value">{{ formatDuration(callData.data.callDuration || '00:00:00') }}</span>
          <span class="label">{{ 'CALL_DETAILS_PAGE.CALL_DURATION' | translate }}</span>
        </div>
        <span class="separator">|</span>
        <div class="summary-item">
          <span class="value">{{
            (callData.data.invoiceDetails !== null ? callData.data.invoiceDetails.totalAmount : 0)
              | currency
                : (callData.data.invoiceDetails !== null
                    ? callData.data.invoiceDetails.currency
                    : 'USD')
          }}</span>
          <span class="label">{{ 'CALL_DETAILS_PAGE.CALL_COST' | translate }}</span>
        </div>
        <span class="separator">|</span>
        <div class="summary-item">
          <span class="value">{{
            callData.data.invoiceDetails !== null
              ? callData.data.invoiceDetails.invoiceStatus
              : statuses.PENDING
          }}</span>
          <span class="label">{{ 'CALL_DETAILS_PAGE.INVOICE_STATUS' | translate }}</span>
        </div>
        <div class="icon-container">
          <i class="fas fa-phone card-icon"></i>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4">
      <div class="dispute-status">
        <div class="status-item">
          <span class="status-text">
            {{ callDisputeCounts?.Resolved || 0 }}
          </span>
          <span class="status-label">{{ 'CALL_DETAILS_PAGE.RESOLVED_DISPUTES' | translate }}</span>
        </div>
        <span class="separator">|</span>
        <div class="status-item">
          <span class="status-text">
            {{ callDisputeCounts?.Open || 0 }}
          </span>
          <span class="status-label">{{ 'CALL_DETAILS_PAGE.OPEN_DISPUTES' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="row g-3">
    <div class="col-md-6 col-sm-12">
      <div class="payment-overview">
        <h4 class="table-heading">
          {{ 'CALL_DETAILS_PAGE.PAYMENT_OVERVIEW_TABLE_HEADING' | translate }}
        </h4>
        <table class="table">
          <tr>
            <td>{{ 'CALL_DETAILS_PAGE.PAYMENT_OVERVIEW.CALL_TYPE' | translate }}</td>
            <td>{{ callData?.data?.isVideo ? 'Video' : 'Audio' }}</td>
          </tr>
          <tr>
            <td>{{ 'CALL_DETAILS_PAGE.PAYMENT_OVERVIEW.START_TIME' | translate }}</td>
            <td>
              {{
                callData?.data?.startTime !== null
                  ? getConvertedDate(callData?.data?.startTime ?? '')
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td>{{ 'CALL_DETAILS_PAGE.PAYMENT_OVERVIEW.END_TIME' | translate }}</td>
            <td>
              {{
                callData?.data?.endTime !== null
                  ? getConvertedDate(callData?.data?.endTime ?? '')
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td>{{ 'CALL_DETAILS_PAGE.PAYMENT_OVERVIEW.TOTAL_DURATION' | translate }}</td>
            <td>{{ formatDuration(callData?.data?.callDuration || '00:00:00') }}</td>
          </tr>
          <tr>
            <td>{{ 'CALL_DETAILS_PAGE.PAYMENT_OVERVIEW.INVOICE_NUMBER' | translate }}</td>
            <td>{{ callData?.data?.invoiceDetails?.invoiceNumber }}</td>
          </tr>
          <tr>
            <td>{{ 'CALL_DETAILS_PAGE.CALL_COST' | translate }}</td>
            <td class="call-cost">
              {{
                (callData?.data?.invoiceDetails !== null
                  ? callData?.data?.invoiceDetails?.totalAmount
                  : 0
                )
                  | currency
                    : (callData?.data?.invoiceDetails !== null
                        ? callData?.data?.invoiceDetails?.currency
                        : 'USD')
              }}
            </td>
          </tr>
          <tr>
            <td>{{ 'CALL_DETAILS_PAGE.PAYMENT_OVERVIEW.INVOICE_STATUS' | translate }}</td>
            <td>
              <div class="payout-status">
                {{
                  callData?.data?.invoiceDetails !== null
                    ? callData?.data?.invoiceDetails?.invoiceStatus
                    : statuses.PENDING
                }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="dispute-overview">
        <ng-container *ngIf="disputeData && disputeData.length > 0; else noDisputeMessage">
          <div
            class="dispute-card"
            *ngFor="let dispute of disputeData; let i = index"
            [hidden]="i !== currentIndex"
          >
            <div class="controls-container">
              <h4 class="table-heading">
                {{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW_TABLE_HEADING' | translate }}
              </h4>
              <div class="controls" *ngIf="disputeData && disputeData.length > 1">
                <i
                  class="pi pi-chevron-left arrow"
                  (click)="previous()"
                  [class.disabled]="currentIndex === 0"
                ></i>
                <i
                  class="pi pi-chevron-right arrow"
                  (click)="next()"
                  [class.disabled]="currentIndex === disputeData.length - 1"
                ></i>
              </div>
            </div>
            <table class="table">
              <tr>
                <td>{{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW.DISPUTE_ID' | translate }}</td>
                <td>{{ dispute.uid }}</td>
              </tr>
              <tr>
                <td>{{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW.DISPUTE_TYPE' | translate }}</td>
                <td>{{ dispute.disputeType }}</td>
              </tr>
              <tr>
                <td>{{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW.RAISED_BY' | translate }}</td>
                <td>{{ dispute.raisedByName }}</td>
              </tr>
              <tr>
                <td>{{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW.RAISED_ON' | translate }}</td>
                <td>
                  {{ dispute?.createdOn !== null ? getConvertedDate(dispute?.createdOn ?? '') : '' }}
                </td>
              </tr>
              <tr>
                <td>{{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW.LAST_UPDATED_ON' | translate }}</td>
                <td>
                  {{
                    dispute?.modifiedOn !== null ? getConvertedDate(dispute?.modifiedOn ?? '') : ''
                  }}
                </td>
              </tr>
              <tr>
                <td>{{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW.DISPUTE_COMMENTS' | translate }}</td>
                <td>{{ dispute.description }}</td>
              </tr>
              <tr>
                <td class="overview-status-label">
                  {{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW.STATUS' | translate }}
                </td>
                <td class="bg-white">
                  <form #statusForm="ngForm" class="status-form">
                    <p-dropdown
                      class="custom-dropdown"
                      name="disputeStatus"
                      [(ngModel)]="dispute.disputeStatus"
                      [options]="disputeStatuses"
                      optionLabel="status"
                      optionValue="status"
                      [ngClass]="{
                        'status-success': dispute.disputeStatus === statuses.RESOLVED,
                        'status-danger': dispute.disputeStatus === statuses.OPEN,
                        'status-warning': dispute.disputeStatus === statuses.UNDER_REVIEW,
                      }"
                    ></p-dropdown>
                    <div class="update-comment bg-white rounded mt-2">
                      <label for="comment" class="form-label">
                        <span class="fw-normal">{{
                          'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.COMMENT' | translate
                        }}</span>
                        <span class="text-muted">
                          ({{
                            'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.FOR_STATUS_UPDATE' | translate
                          }})
                        </span>
                      </label>

                      <textarea
                        id="comment"
                        name="disputeComment"
                        class="form-control reply-box"
                        rows="3"
                        [(ngModel)]="disputeComment"
                        required
                        #disputeCommentCtrl="ngModel"
                      ></textarea>

                      <div class="text-end mt-2">
                        <button
                          type="button"
                          class="btn btn-custom-green"
                          [disabled]="!statusForm.valid || !statusForm.dirty"
                          (click)="updateDisputeStatus(dispute, disputeComment)"
                        >
                          {{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.UPDATE' | translate }}
                        </button>
                      </div>
                    </div>
                  </form>
                </td>
              </tr>
            </table>
          </div>
        </ng-container>
        <ng-template #noDisputeMessage>
          <h4 class="table-heading">
            {{ 'CALL_DETAILS_PAGE.DISPUTE_OVERVIEW_TABLE_HEADING' | translate }}
          </h4>
          <table class="table">
            <tbody>
              <tr>
                <td colspan="4" class="no-data-available">
                  {{ 'COMMON.NO_AVAILABLE' | translate }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
    </div>
  </div>
</div>
